var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingsicon = function SvgSettingsicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.25,
    d: "M10.002 12.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 1.25,
    d: "M18 11V9l-1.854-.772a6.36 6.36 0 0 0-.546-1.323l.763-1.854-1.414-1.415-1.854.764a6.343 6.343 0 0 0-1.323-.546L11 2H9l-.772 1.854a6.361 6.361 0 0 0-1.323.546L5.05 3.636 3.636 5.051 4.4 6.905c-.23.414-.412.858-.546 1.323L2 9v2l1.854.772c.134.465.316.908.546 1.323l-.764 1.854 1.415 1.414 1.854-.763c.414.23.858.412 1.323.546L9 18h2l.772-1.854a6.36 6.36 0 0 0 1.323-.546l1.854.763 1.414-1.414-.763-1.854c.23-.414.412-.858.546-1.323L18 11Z"
  })));
};
export default SvgSettingsicon;